export default __webpack_public_path__ + "static/media/iconeDocMaior.216c536d.png";